import { ImageSourcePropType } from 'react-native'

export interface Meditation {
  /* Unique id of the meditation */
  id: string
  /* Title of the meditation */
  title: string
  /* Description of the meditation */
  subtitle: string
  /* How long is the meditation in minutes */
  time: number
  /* The order of the meditation in the list */
  order: number
  /* URL of the image to show */
  image: ImageSourcePropType
  /* URI of the audio file */
  uri: string
  /* Track ID from the back-end */
  track: number
  /* author */
  author: string
  /* url */
  url: string
}
export interface MeditationItem {
  item: Meditation
}

export const exercises: Meditation[] = [
  {
    id: 'ff171f80-5960-41e7-965c-1f9bcf31e09a',
    order: 0,
    title: 'Finger Induced Lucid Dream',
    track: 0,
    subtitle: 'Finger Induced Lucid Dream',
    time: 2,
    uri: 'https://lucid-code.com/LSDBase/Anthems/FIELD.mp3',
    image: require('../assets/images/field.jpg'),
    author: 'Michael Paul Coder',
    url: 'https://lucidcode.com'
  },
  {
    id: 'af171f80-5960-41e7-965c-1f9bcf31e09a',
    order: 0,
    title: 'Reality Checks',
    track: 0,
    subtitle: 'Dream Induced Lucid Dream',
    time: 2,
    uri: '',
    image: require('../assets/images/reality2.jpg'),
    author: 'Michael Paul Coder',
    url: 'https://lucidcode.com'
  },
]

export const mindfulness: Meditation[] = [
  {
    id: 'ff171f80-5960-41e7-965c-1f9bcf31e04f',
    order: 1,
    title: 'Body Scan',
    track: 2,
    subtitle: 'Inward Focus',
    time: 45,
    uri: 'https://lucid-code.com/LSDBase/Mindfulness/BodyScan.mp3',
    image: require('../assets/images/focus.jpg'),
    author: 'UCSD Center for mindfulness', // ,
    url: 'https://www.freemindfulness.org/download'
  },
  {
    id: 'ff171f80-5960-41e7-965c-1f9bcf31e03f',
    order: 2,
    title: 'Breathing Space',
    track: 2,
    subtitle: 'Mindfulness of Breath',
    time: 5,
    uri: 'https://lucid-code.com/LSDBase/Mindfulness/BreathingSpace.mp3',
    image: require('../assets/images/under-water.jpg'),
    author: 'Vidyamala Burch', // ,
    url: 'https://www.freemindfulness.org/download'
  },
  {
    id: 'ff171f80-5960-41e7-965c-1f9bcf31e02f',
    order: 2,
    title: 'Mountain Being',
    track: 1,
    subtitle: 'Guided Imagery',
    time: 8,
    uri: 'https://lucid-code.com/LSDBase/Mindfulness/MountainMeditation.mp3',
    image: require('../assets/images/mountainl.jpg'),
    author: 'Peter Morgan', // ,
    url: 'https://www.freemindfulness.org/download'
  },
]

export const meditations = {
  exercises,
  mindfulness,
}
